// extracted by mini-css-extract-plugin
export default {"container":"LeftNav_container__c7jdy","nav":"LeftNav_nav__lRLks","link":"LeftNav_link__vEwBE","active":"LeftNav_active__MOeV4","mainContent":"LeftNav_mainContent__cxHdO"};